(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-copy-link]');
    if (!button) return;
    const status = button.closest('.blog-share')?.querySelector('[data-copy-status]');
    try {
      await navigator.clipboard.writeText(button.dataset.copyLink);
      if (status) status.textContent = button.dataset.copiedLabel;
    } catch (error) {
      window.prompt('', button.dataset.copyLink);
    }
  });

  const toc = document.querySelector('[data-blog-toc]');
  if (toc && 'IntersectionObserver' in window) {
    const links = new Map(
      [...toc.querySelectorAll('a[href^="#"]')].map((link) => [decodeURIComponent(link.hash.slice(1)), link])
    );
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          links.forEach((link) => link.removeAttribute('aria-current'));
          links.get(entry.target.id)?.setAttribute('aria-current', 'true');
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    links.forEach((_, id) => {
      const heading = document.getElementById(id);
      if (heading) observer.observe(heading);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
